import { parse } from '../../util/urlHelpers';
import { verify } from '../../ducks/emailVerification.duck';

// Dummy reducer to satisfy combineReducers
const initialState = {};
function reducer(state = initialState, _action = {}) {
  return state;
}

export default reducer;

// ================ Thunks ================ //

export const loadData = (params, search) => {
  const urlParams = parse(search);
  const verificationToken = urlParams.t;
  const token = verificationToken ? `${verificationToken}` : null;
  return verify(token);
};
